import React, { FC } from 'react';
import { UserVerificationStateEnum } from '@src/graphql/generated';
import { StageCardStage } from './Stage';
import { Stage } from './Stage/enums/stage.enum';
import { ConnectAsWell } from './ConnectAswell';
import { StageCardProps } from './props';
import './styles.scss';

export const StageCard: FC<StageCardProps> = ({
  activeOpeningId,
  isConnectActionDisabled,
  messagedByCompaniesTotalCount,
  connectedWithCompaniesTotalCount,
  onConfirm,
  userVerificationState,
}) => {
  const isInConversation = messagedByCompaniesTotalCount > 0;

  const isOffTheMarket = [UserVerificationStateEnum.CANCELLED, UserVerificationStateEnum.EXPIRED].includes(
    userVerificationState,
  );

  if (isInConversation && !isOffTheMarket) {
    return (
      <div className="stage-card">
        <StageCardStage stage={Stage.IS_IN_CONVERSATION} />

        {!isConnectActionDisabled && <ConnectAsWell activeOpeningId={activeOpeningId} onConfirm={onConfirm} />}
      </div>
    );
  }

  if (isOffTheMarket) {
    return (
      <div className="stage-card">
        <StageCardStage stage={Stage.IS_OFF_THE_MARKET} />
      </div>
    );
  }

  return (
    <div className="stage-card">
      <StageCardStage stage={Stage.IS_COLLECTING_OFFERS} />
      {(messagedByCompaniesTotalCount > 0 || connectedWithCompaniesTotalCount > 0) && !isConnectActionDisabled && (
        <ConnectAsWell activeOpeningId={activeOpeningId} onConfirm={onConfirm} />
      )}
    </div>
  );
};
